import { faDollarSign, faUsers } from '@fortawesome/free-solid-svg-icons';
import { headerNames } from './constants';

const parentPath = '/sales-administration';

export const salesAdministrationRoutes = {
  salesAdministration: {
    path: `${parentPath}`,
    key: 'sales-administration',
    value: headerNames?.salesAdministration,
    icon: faDollarSign,
    QADataTag: 'salesAdministrationNav',
  },
  salesRoles: {
    path: `${parentPath}?t=sales-roles`,
    key: 'sales-roles',
    value: 'Sales Roles',
    icon: faDollarSign,
    QADataTag: 'salesRolesNav',
    permission: 'membership.roles.view',
  },
  defaultCommissions: {
    path: `${parentPath}?t=default-commissions`,
    key: 'default-commissions',
    value: 'Default Commissions',
    icon: faUsers,
    QADataTag: 'defaultCommissionsNav',
    permission: 'membership.members.update',
  },
};
